/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type CancellationPolicyEnum =
  (typeof CancellationPolicyEnum)[keyof typeof CancellationPolicyEnum];

export const CancellationPolicyEnum = {
  '0day': '0day',
  '1day': '1day',
  '3day': '3day',
  '7day': '7day',
} as const;
